import type { GameMeta } from '@gmp/game-sdk';

export const battleBotsMeta = {
  id: 'battle-bots',
  name: 'Battle Bots',
  tagline: 'Modular cartoon robots draft, aim and fight in the Scrapyard Circuit.',
  description:
    'Pick a chassis, a skill and a passive, place one trap or boon in the arena, then fight. Aim, fire, dash, use your skill, charge a super shot and grab pickups. Clean knockouts score; knocked-out bots respawn after a short countdown.',
  minPlayers: 2,
  maxPlayers: 8,
  estimatedMinutes: [3, 5],
  usesMedia: false,
  modes: [{ id: 'knockout', name: 'Knockout Score', description: 'Score clean knockouts and assists. Highest score when the timer ends wins.' }],
  theme: { primary: '#ffb020', secondary: '#4cc9f0', background: '#14110d', ink: '#fff6e5' },
  readiness: 'beta',
  genre: 'Arena combat',
  controls: 'touch-action',
  category: 'versus',
  instructions: [
    { icon: 'Sparkles', title: 'Draft', body: 'Choose a chassis (fast, tanky or tricky), a skill, a passive and one arena piece. All revealed before the fight.' },
    { icon: 'Hand', title: 'Move and aim', body: 'Thumb down anywhere on the left to drive, on the right to aim: your bot fires while you hold, and shots snap onto a bot near your aim.' },
    { icon: 'Zap', title: 'Dash, skill, super', body: 'Dash (or double-tap the drive area) to slip out of trouble, briefly untouchable. Dealing damage fills Overdrive: when full, Super fires a heavy piercing shot.' },
    { icon: 'Sparkles', title: 'Pickups', body: 'Repair kits (+45), Rapid fire and Shields drop on the floor during the fight. Drive over them.' },
    { icon: 'Trophy', title: 'Knockouts', body: 'A knockout is 100, an assist 30. A bot on a 3-knockout streak carries a +50 bounty. Knocking out the same bot again within 25 s is worth less.' },
  ],
} satisfies GameMeta;
